import React, { useState, useEffect } from 'react'
import '../scss/claimHistory.scss'
//import '../scss/claimAudit.scss'
import axios from 'axios';
import {  AUDIT_SERVICE, REACT_APP_VAM_ENDPOINT } from '../urls';
import LoadingPage from '../reusableComponents/loader/loadingPage';
import NoDataFound from '../utilsComponent/noDataFound';
import { format } from 'date-fns';
import ViewMoreLess from '../reusableComponents/ViewMoreLess';
import { axiosRequest } from '../service';
const ClaimAudit = (props) => {
    const { claimDetailCookie, productName, searchType, productID, searchValue, claimId } = props;
    const [claimAuditsList, setClaimAuditsList] = useState("");
    const [loadingAuditList, setLoadingAuditList] = useState(false)
     // Check id the claim audit list duplicates based on the activity name for payment related audit trails
    useEffect(() => {
        setLoadingAuditList(true)
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${AUDIT_SERVICE}/auditService/getClaimAudit/${claimDetailCookie?.claimNo || claimId}`).then(data => {
            // Create a copy of the data array to avoid mutating the original
            const filteredData = [...data.data];
            // Iterate over the array and remove duplicates
            for (let auditTrailIndex = 1; auditTrailIndex < filteredData.length; auditTrailIndex++) {
                let audit = filteredData[auditTrailIndex];
                let previousAudit = filteredData[auditTrailIndex - 1];
                            // Remove duplicate entries based on activity name and claim sub status
                if (audit.activityName === previousAudit.activityName) {
                    if (audit.claimSubStatus !== 'Field Survey Requested' && audit.claimSubStatus == previousAudit.claimSubStatus && audit.remarks == previousAudit.remarks) {
                        filteredData.splice(auditTrailIndex - 1, 1);
                        auditTrailIndex--;
                    }
                }
            }
            setClaimAuditsList(filteredData);
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setLoadingAuditList(false)
        })
    }, [])
    return (
            <div className={claimDetailCookie ? 'inner-box2Field mt-3' : 'claim-processing-tabs bg-white rounded'}>
                {
                    loadingAuditList ? <LoadingPage/> : (
                        <div className={`detailsHistory ${!claimDetailCookie ? "h-auto" : ""}`}>
                            <div className='d-flex align-items-end justify-content-between'>
                                <h3 className="heading_h2History ms-3 mt-4" id="historyHistory">Audit Trail</h3>
                            </div>
                            {
                                claimAuditsList && claimAuditsList.length > 0 ? (
                                    <div className="row">
                                        <section className="p-4">
                                            <div className="overflowHistory">
                                                <table className="table table-strip mt-3 text-left">
                                                    <thead>
                                                        <tr>
                                                            <th>SL No.</th>
                                                            <th>Activity Name</th>
                                                            <th>Claim Status</th>
                                                            <th>Claim sub status <span style={{display:'none'}}><img  src="/kshemaImages/Vector.png" alt="dropdown vector" width="auto" height="8px" /></span></th>
                                                            <th>Remarks</th> 
                                                            <th>Actioned Date & Time <span style={{display:'none'}}><img  src="/kshemaImages/Vector.png" alt="dropdown vector" width="auto" height="8px" /></span></th>
                                                            <th>Actioned By</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>                                                        
                                                        {
                                                            claimAuditsList && claimAuditsList.length > 0 && claimAuditsList?.map((list, index) => (
                                                                <tr key={index}>
                                                                    <td>{claimAuditsList.length - index}</td>
                                                                    <td>{list.activityName}</td>
                                                                    <td>{list.claimStatus}</td>
                                                                    <td>{list.claimSubStatus}</td>
                                                                    <td className="remarks">
                                                                        <div className={`remarks ${list.activityName === "Cause Of Loss" && list?.remarks?.includes('not matching') ? 'has-activity' : 'no-activity'}`}>
                                                                            <ViewMoreLess text={list.remarks}/>
                                                                       </div> 
                                                                       </td>
                                                                    <td>{format(new Date(list.createdDate), 'dd-MM-yyyy, hh:mm a')}</td>
                                                                    <td>{list.createdBy}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </section>
                                    </div>
                                ) : <NoDataFound text="No Data Found"/>
                            }
                        </div>
                    )
                }
            </div>
    )
}

export default ClaimAudit
